<template>
    <div class="my-8">
        <h3 ref="title" class="text-dark mb-2 text-2xl">
            <span class="font-bold">Latest reviews</span> for

            <template v-if="product.brand">&nbsp;{{ product.brand.name }}</template>

            {{ product.name }} tyres
        </h3>

        <p class="text-dark text-sm mb-4">The most recent reviews left by our users</p>

        <MasonryWall :items="reviews" :columns="2" :gap="16" v-slot="slotProps">
            <ReviewCard :key="slotProps.index" :review="slotProps.item"></ReviewCard>
        </MasonryWall>

        <AppButton v-if="reviews.length > 0 && currentPage < pageMeta.last_page" :loading="loading" @click="loadMore">
            Load more reviews
        </AppButton>
    </div>
</template>

<script>
import ReviewCard from "@/Components/Reviews/ReviewCard";
import MasonryWall from "@/Components/MasonryWall";
import AppButton from "@/Components/AppButton";

export default {
    components: {AppButton, ReviewCard, MasonryWall},
    props: {
        product: Object
    },
    data() {
        return {
            pageMeta: null,
            reviews: [],
            currentPage: 1,
            loading: false
        };
    },
    mounted() {
        this.getReviews();
    },
    methods: {
        async getReviews() {
            this.loading = true;

            const response = await axios.get(this.route("products.reviews.latest", this.product), {
                params: {
                    page: this.currentPage
                }
            });

            this.pageMeta = response.data;

            if (this.currentPage === 1) {
                this.reviews.splice(0);
            }

            const reviews = [...this.reviews];
            reviews.push(...response.data.data);

            this.reviews = reviews;

            this.loading = false;
        },
        loadMore() {
            this.currentPage++;

            this.getReviews();
        }
    }
};
</script>

<style scoped>

</style>
